import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import * as fromApp from '../modules/core/store/app.state';

/**
 * Inject the user's currently-active brand id as `X-Brand-Id` on every
 * authenticated outbound request, so brand-scoped backend endpoints can
 * filter without having to thread the brand through every query string.
 *
 * Skipped for:
 *  - login / token refresh (no auth context yet)
 *  - the my-brands endpoint itself (it's what populates the brand list)
 */
@Injectable()
export class AddBrandHeaderInterceptor implements HttpInterceptor {
  constructor(private store: Store<fromApp.AppState>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      req.headers.has('X-Brand-Id')
      || req.url.includes('entrance/login')
      || req.url.includes('entrance/refresh-login-token')
      || req.url.includes('/brands/my-brands')
    ) {
      return next.handle(req);
    }

    return this.store.select(fromApp.selectActiveBrandId).pipe(
      take(1),
      switchMap((brandId: number | null) => {
        if (brandId == null) {
          return next.handle(req);
        }
        const withBrand = req.clone({
          setHeaders: { 'X-Brand-Id': String(brandId) },
        });
        return next.handle(withBrand);
      }),
    );
  }
}
